{
  "close": "Cerrar"
}
